<template>
  <div class="flex flex-col flex-grow">
    <img
      v-if="!isCorporation"
      class="login-page__logo f-password-img"
      :srcset="`${forgetPasswordImage}, ${forgetPasswordImage2x}`"
      :src="forgetPasswordImage"
      alt="Thrive"
    />
    <h2
      class="page-title color-text text-left text-28 text-text pt-7 tracking-tight"
      :class="titleClass"
      v-html="title"
    ></h2>
    <p class="page-subtitle text-left text-12 text-light_grey f-password-txt">
      {{ content }}
    </p>
    <div class="flex-grow py-5 flex flex-col justify-center">
      <Telephone v-model="phoneNumber" />
    </div>
    <div class="table mx-auto mb-3">
      <button
        type="button"
        @click="$emit('next', phoneNumber)"
        class="btn shadow-primary"
        :class="isActive"
      >
        {{$t('Next')}}
    </button>
    </div>
  </div>
</template>
<script>
import Telephone from "../UI/Telephone.vue";
import Button from "../UI/Button.vue";

export default {
  components: {
    Telephone,
    Button
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    phone: {
      type: String,
      default: ""
    }
  },
  mounted() {
    if (this.phone) {
      this.phoneNumber = this.phone;
    }
  },
  data() {
    return {
      phoneNumber: ""
    };
  },

  computed: {
    isCorporation() {
      return this.$getState("corporation")["is"];
    },
    forgetPasswordImage() {
      return `${this.$getState("appUrl")}/img/pwa/login/f-password.png`;
    },
    forgetPasswordImage2x() {
      return `${this.$store.state.appUrl}/img/pwa/login/f-password@2x.png`;
    },
    titleClass() {
      return {
        "mt-75": this.isCorporation
      };
    },
    isActive () {
      return {
        "bg-btn-bg": this.phoneNumber.length,
        "bg-grey-1": !this.phoneNumber.length
      }
    }
  }
};
</script>
<style scoped>
.mt-75 {
  margin-top: 75px;
}
</style>
